import { Link } from 'react-router-dom'
import { ROUTES } from '../../constants/routes.constants'
import { Button } from '../components/atoms/Button'

export function NotFoundPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <p className="font-body text-body uppercase tracking-wider text-terra">404</p>
      <h1 className="mt-2 font-heading text-display text-charcoal">Page not found</h1>
      <p className="mt-6 font-body text-body-lg text-text-secondary">
        The page you&apos;re looking for doesn&apos;t exist — yet, or anymore.
      </p>
      <div className="mt-8">
        <Link to={ROUTES.HOME}>
          <Button variant="primary">Take me home</Button>
        </Link>
      </div>
    </div>
  )
}
